import { render } from "./AppModalDelete.vue?vue&type=template&id=12d854a3&scoped=true"
import script from "./AppModalDelete.vue?vue&type=script&lang=js"
export * from "./AppModalDelete.vue?vue&type=script&lang=js"

import "./AppModalDelete.vue?vue&type=style&index=0&id=12d854a3&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d854a3"]])

export default __exports__